// extracted by mini-css-extract-plugin
module.exports =  {"adminIntercomSettingsTeamInboxes":"r2wPqC3U","description":"rwjMSj0X","error":"ehhdmQH7","filterContainer":"Kt6HO07q","saveButton":"cXPzD1x4","saveError":"CcGgHutY"};